import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../api';
import type { CommentRow } from '../types';

export function useComments(legacyId: string | undefined) {
  return useQuery({
    enabled: Boolean(legacyId),
    queryKey: ['comments', legacyId],
    queryFn: () => api.comments.list(legacyId as string),
  });
}

export function useCreateComment(legacyId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: string) => api.comments.create(legacyId, { body }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['comments', legacyId] }),
  });
}

export function useDeleteComment(legacyId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (commentId: string) => api.comments.delete(legacyId, commentId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['comments', legacyId] }),
  });
}

export type { CommentRow };